export default __webpack_public_path__ + "static/135-min-min-8acc800b30a62eb4ac6e6a7ecc4a563c.jpg";